/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomerDto } from './CustomerDto';
import {
    CustomerDtoFromJSON,
    CustomerDtoFromJSONTyped,
    CustomerDtoToJSON,
} from './CustomerDto';

/**
 * 
 * @export
 * @interface AuthenticateCustomerDto
 */
export interface AuthenticateCustomerDto {
    /**
     * 
     * @type {CustomerDto}
     * @memberof AuthenticateCustomerDto
     */
    customer: CustomerDto;
    /**
     * 
     * @type {string}
     * @memberof AuthenticateCustomerDto
     */
    token: string;
}

/**
 * Check if a given object implements the AuthenticateCustomerDto interface.
 */
export function instanceOfAuthenticateCustomerDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "customer" in value;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function AuthenticateCustomerDtoFromJSON(json: any): AuthenticateCustomerDto {
    return AuthenticateCustomerDtoFromJSONTyped(json, false);
}

export function AuthenticateCustomerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticateCustomerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customer': CustomerDtoFromJSON(json['customer']),
        'token': json['token'],
    };
}

export function AuthenticateCustomerDtoToJSON(value?: AuthenticateCustomerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customer': CustomerDtoToJSON(value.customer),
        'token': value.token,
    };
}

